import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";
import { checkout } from "./checkoutActions";

export function createOpenpayOrder(sale) {
    const request = axios.post(urls.OPENPAY_CREATE_URL, sale);
    return { type: ActionTypes.CREATE_OPENPAY_ORDER, payload: request };
}


export function getOrderStatus(openpayOrderId) {
    const url = `${urls.OPENPAY_GET_STATUS_URL.replace(":openpayOrderId", openpayOrderId)}`;
    const request = axios.get(url);
    return { type: ActionTypes.OPENPAY_GET_STATUS, payload: request };
}

export function logOpenpayCallbackResponse(logInfo) {
    const request = axios.post(urls.OPENPAY_LOG_CALLBACK_URL, logInfo);
    return { type: ActionTypes.OPENPAY_LOG_CALLBACK, payload: request };
}


export function saveOpenpayPlanAndCheckout(openpayPlan) {
    return (dispatch, getState) => {
        const response = dispatch({
            type: ActionTypes.SAVE_OPENPAY_PLAN,
            payload: new Promise(function (resolve, reject) { resolve(openpayPlan); })
        });

        response.then(() => {
            const { checkoutSale, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(checkout(checkoutSale));
            }
        })
    }
}

export function resetOpenpayPlan() {
    return (dispatch, getState) => {
        const response = dispatch({
            type: ActionTypes.RESET_OPENPAY_PLAN,
            payload: new Promise(function (resolve, reject) { resolve(); })
        });
    }
}

